import React, { useContext } from "react";
import styles from "./navigation.module.css";
import { animateScroll as scroll } from "react-scroll";
import { Context } from "../../../global/store";

const Navigation = () => {
  const [state, dispatch] = useContext(Context);
  // console.log(state.sections);
  const links = state.sections;

  const onClickNavItem = (id) => {
    dispatch({ type: "SET_ACTIVE_SECTION", payload: { id: id } });
  };

  // =================================================================
  // Scrolling Functionality
  const smooth = (e, pos, id) => {
    e.preventDefault();
    onClickNavItem(id);
    scroll.scrollTo(pos);
  };

  //Change Active on Scroll
  

  // =====================================
  const list = links.map((item) => {
    let clss = null;
    let circle = <i className="fal fa-circle"></i>;
    if (item.active) {
      clss = styles.current;
      circle = <i className="fad fa-circle"></i>;
    }
    return (
      <li key={item.id}>
        <a
          href={item.href}
          className={clss}
          onClick={(e) => smooth(e, item.pos, item.id)}
        >
          {circle}
          {item.title}
        </a>
      </li>
    );
  });

  return (
    <div className={`${styles.box} hidden lg:block`}>
      <div className={styles.nav}>
        <div className={styles.list}>{list}</div>
      </div>
    </div>
  );
};

export default Navigation;
